import React from 'react';
import { Check, CreditCard, Lock } from 'lucide-react';
export function PricingSection() {
  return <section id="oferta" className="py-5 sm:py-16 bg-[#0a1628] relative" data-id="element-97">
      <div className="max-w-3xl mx-auto px-3 sm:px-6" data-id="element-98">
        <div className="text-center mb-4 sm:mb-8" data-id="element-99">
          <h2 className="text-xl sm:text-4xl md:text-5xl font-black text-white uppercase tracking-tight" data-id="element-100">
            Oferta Especial
          </h2>
          <div className="h-0.5 sm:h-1 w-16 sm:w-20 bg-[#fbbf24] mx-auto mt-2 sm:mt-3 rounded-full" data-id="element-101"></div>
        </div>

        {/* MAIN OFFER BOX */}
        <div className="bg-white rounded-xl shadow-2xl overflow-hidden border-4 border-[#fbbf24] mb-5 sm:mb-12" data-id="element-102">
          <div className="bg-[#fbbf24] py-1.5 sm:py-3 text-center" data-id="element-103">
            <span className="text-[#0a1628] font-black text-xs sm:text-lg tracking-wider uppercase" data-id="element-104">
              ⭐ EL KIT MÁS VENDIDO ⭐
            </span>
          </div>

          <div className="p-3 sm:p-8 text-center" data-id="element-105">
            <h3 className="text-lg sm:text-3xl font-bold text-gray-900 mb-2 sm:mb-4" data-id="element-106">
              Kit Completo Filosofía Lista
            </h3>

            <div className="bg-gray-50 rounded-lg p-2.5 sm:p-5 mb-3 sm:mb-6 text-left max-w-sm mx-auto border border-gray-200" data-id="element-107">
              <p className="font-bold text-gray-700 mb-2 sm:mb-3 uppercase text-[10px] sm:text-xs tracking-wide text-center" data-id="element-108">
                Incluye todo esto:
              </p>
              <ul className="space-y-1.5 sm:space-y-2" data-id="element-109">
                {['Kit completo de contenidos filosóficos', 'BONUS: Kit Premium de Evaluaciones', 'BONUS: Actividades Filosóficas', 'BONUS: Plantillas Profesionales de Planificación', 'Entrega por Drive (PDF)', 'Garantía de 7 días'].map((item, i) => <li key={i} className="flex items-center text-gray-800 font-medium text-xs sm:text-sm" data-id="element-110">
                    <Check className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 mr-2 flex-shrink-0" strokeWidth={3} data-id="element-111" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col items-center justify-center mb-2 sm:mb-3" data-id="element-112">
              <span className="text-gray-400 text-sm sm:text-xl line-through font-medium mb-1" data-id="element-113">
                $19.99
              </span>
              <div className="relative flex items-center justify-center" data-id="element-114">
                <div className="absolute inset-0 bg-[#16a34a]/20 blur-2xl rounded-full" data-id="element-115"></div>
                <span className="relative text-[#16a34a] text-4xl sm:text-6xl md:text-7xl font-black tracking-tight drop-shadow-[0_0_20px_rgba(22,163,74,0.5)] animate-pulse-subtle" data-id="element-116">
                  $13.99
                </span>
              </div>
              <span className="text-[#16a34a] text-sm sm:text-lg font-bold tracking-widest uppercase mt-1" data-id="element-117">
                USD
              </span>
            </div>

            <p className="text-base sm:text-xl text-gray-600 mb-3 sm:mb-4 font-bold" data-id="element-118">
              💳 Pagarás en la moneda de tu país.
            </p>

            <a href="https://checkout.docentesfelices.online/cart/55503806496841:1" className="block w-full bg-[#16a34a] hover:bg-green-700 text-white text-base sm:text-2xl font-black py-3.5 sm:py-4 px-4 rounded-lg shadow-[0_4px_0_rgb(21,128,61)] hover:shadow-[0_2px_0_rgb(21,128,61)] hover:translate-y-[2px] transition-all uppercase mb-2 sm:mb-3" data-id="element-119">
              COMPRAR AHORA →
            </a>

            <p className="text-gray-500 text-[10px] sm:text-xs" data-id="element-120">
              Luego del pago, te enviaremos el acceso por Drive.
            </p>
          </div>
        </div>

        {/* UPSELL BOX */}
        <div className="bg-[#1e293b] rounded-xl shadow-2xl overflow-hidden border border-gray-700 relative" data-id="element-121">
          <div className="absolute top-0 right-0 bg-[#dc2626] text-white text-[9px] sm:text-xs font-bold px-2 py-0.5 sm:py-1 rounded-bl-lg uppercase" data-id="element-122">
            Oferta Limitada
          </div>

          <div className="p-3 sm:p-6 md:p-8" data-id="element-123">
            <div className="flex flex-col gap-3 sm:gap-6 items-center" data-id="element-124">
              {/* Top Content */}
              <div className="w-full text-center" data-id="element-125">
                <span className="inline-block bg-blue-600 text-white text-[9px] sm:text-xs font-bold px-2 py-0.5 rounded-full mb-2 uppercase tracking-wide" data-id="element-126">
                  Pack Profesional
                </span>
                <h3 className="text-lg sm:text-2xl font-bold text-white mb-1" data-id="element-127">
                  KIT COMPLETO FILOSOFÍA LISTA + EVALUACIÓN FILOSÓFICA 360
                </h3>

                {/* Upsell Image */}
                <div className="mb-3 sm:mb-4" data-id="element-128">
                  <a href="https://checkout.docentesfelices.online/cart/55503806595145:1" className="block hover:opacity-90 transition-opacity" data-id="element-129">
                    <img src="https://cdn.magicpatterns.com/uploads/vwyKgMpkZmUivDaAcs4MHp/UPSELLFILOSOFIA_(1).png" alt="Pack Profesional Evaluación Filosófica 360" className="w-full max-w-md mx-auto h-auto rounded-lg shadow-lg" data-id="element-130" />
                  </a>
                </div>

                <p className="text-gray-400 mb-3 sm:mb-4 text-xs sm:text-sm" data-id="element-131">
                  Explica todos los temas con estructura clara, evaluaciones
                  profesionales y planificación organizada, lista para usar.
                </p>

                <div className="flex flex-col items-center justify-center gap-1 sm:gap-2 mb-3 sm:mb-4" data-id="element-132">
                  <span className="text-gray-500 text-sm sm:text-lg line-through" data-id="element-133">
                    $25.99
                  </span>
                  <div className="relative flex items-center justify-center" data-id="element-134">
                    <div className="absolute inset-0 bg-[#fbbf24]/20 blur-2xl rounded-full" data-id="element-135"></div>
                    <span className="relative text-[#fbbf24] text-4xl sm:text-6xl md:text-7xl font-black tracking-tight drop-shadow-[0_0_20px_rgba(251,191,36,0.5)] animate-pulse-subtle" data-id="element-136">
                      $16.99
                    </span>
                  </div>
                  <span className="text-[#fbbf24] text-sm sm:text-lg font-bold tracking-widest uppercase" data-id="element-137">
                    USD
                  </span>
                </div>

                <p className="text-base sm:text-xl text-gray-300 mb-3 sm:mb-4 font-bold" data-id="element-138">
                  💳 Pagarás en la moneda de tu país.
                </p>
              </div>

              <div className="w-full flex flex-col md:flex-row gap-3 sm:gap-6 items-center" data-id="element-139">
                {/* Left - CTA */}
                <div className="flex-1 w-full text-center md:text-left" data-id="element-140">
                  <a href="https://checkout.docentesfelices.online/cart/55503806595145:1" className="block w-full bg-[#16a34a] hover:bg-green-700 text-white text-sm sm:text-lg font-bold py-2.5 sm:py-3 px-4 rounded-lg shadow-lg transition-colors text-center mb-2" data-id="element-141">
                    SÍ, QUIERO LA OFERTA →
                  </a>
                </div>

                {/* Right Content - Features list */}
                <div className="flex-1 w-full" data-id="element-142">
                  <p className="text-[10px] sm:text-xs text-gray-400 mb-1.5 font-semibold uppercase tracking-wide" data-id="element-143">
                    Este complemento está pensado para:
                  </p>
                  <ul className="space-y-1 sm:space-y-1.5 text-[10px] sm:text-xs text-gray-300" data-id="element-144">
                    {['Evaluar con criterios claros y profesionales', 'Ahorrar tiempo diseñando exámenes', 'Reducir la subjetividad en la corrección', 'Profesionalizar tu práctica docente'].map((item, i) => <li key={i} className="flex items-start" data-id="element-145">
                        <div className="min-w-[4px] h-[4px] rounded-full bg-[#fbbf24] mt-1 mr-1.5" data-id="element-146"></div>
                        {item}
                      </li>)}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}